import router from './router'
import store from './store'
const whiteList = ['/login'] // 不重定向白名单
router.beforeEach((to, from, next) => {
  
  const isLogin = localStorage.getItem('isLogin') === 'true'
  if(isLogin){
    if(to.path === '/login'){
      next({ path: '/' })
    }else{
      
      if (store.getters.roles.length === 0) {
        store.dispatch('GetInfo').then(res => { // 拉取用户信息
          let userType=res.userType;
          store.dispatch('GenerateRoutes', { userType }).then(() => { // 生成可访问的路由表
           
            store.getters.addRouters.forEach(route => {
             
              if (!route.component) {
                console.error(`路由${route.path}未找到组件，跳过添加`);
                return; // 跳过无效路由
              }
              router.addRoute(route); // 直接传递完整路由对象
            });
            next({ ...to, replace: true });
          })
          
        }).catch((err) => {
          store.dispatch('LogOut').then(() => {
            next({ path: '/' })
          })
        })
      }else {
        next()
      }
    }
  }else {
      if (whiteList.indexOf(to.path) !== -1) {
        next()
      } else {
        next('/login')
      }
    }
  
})

router.afterEach(() => {
 
})



// WEBPACK FOOTER //
// ./src/permission.js